import React from 'react';
import "../scss/QuestionSortType.scss";

const QuestionSortType = ({ questionSortType, onChange = () => { } }) => (
  <div className="question-sort-type">
    <div className="btn-group" role="group" aria-label="Sort Questions">
      <div className="form-check form-check-inline">
        <span className="question-sort-type-label">Sort Questions:</span>

        <input
          className="form-check-input"
          type="radio"
          name="questionSortType"
          id="questionSortTypeRandom"
          value="Random"
          checked={questionSortType === 'Random'}
          onChange={() => onChange('Random')}
        />

        <label
          className="form-check-label"
          htmlFor="questionSortTypeRandom"
          onClick={() => onChange('Random')}
          style={{ cursor: 'pointer' }}
        >
          Random
        </label>
      </div>
      <div className="form-check form-check-inline" style={{ marginRight: ".1em" }}>
        <input
          className="form-check-input"
          type="radio"
          name="questionSortType"
          id="questionSortTypeByTopic"
          value="By Topic"
          checked={questionSortType === 'By Topic'}
          onChange={() => onChange('By Topic')}
        />
        <label
          className="form-check-label"
          htmlFor="questionSortTypeByTopic"
          onClick={() => onChange('By Topic')}
          style={{ cursor: 'pointer' }}
        >
          By Topic
        </label>
      </div>
    </div>
  </div>
);

export default QuestionSortType;
